import { supportsAnchorPositioning } from "@bn-monorepo/js-packages";

if (!supportsAnchorPositioning) {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  (async () => {
    const { applyExplainerEnhancements } = await import("@bn-monorepo/js-packages");
    applyExplainerEnhancements(window?.document);
  })();
}
